/** Public request-access page — share this URL with new / returning users. */
export const ACCESS_PATH = "/access";

export function getAuthRedirectUrl() {
  return `${window.location.origin}${ACCESS_PATH}`;
}

export function isAccessPath(pathname = window.location.pathname) {
  return pathname === ACCESS_PATH || pathname === `${ACCESS_PATH}/`;
}
